import InputType from "@/services/Input/InputType.js";
import Catalog from "../SpecialPriceAdjCatalog";

export default {
  Search: {
    Label: "Cari " + Catalog.AdjNumber.Label,
    Type: InputType.Text,
    MaxLength: 50
  },
  Date: {
    Label: Catalog.Date.Label,
    Type: InputType.Date,
    IsRange: true,
    Required: true,
    RequiredHide: true
  },
  WarehouseID: {
    Label: Catalog.WarehouseID.Label,
    Type: InputType.ID,
    Input: InputType.Select
  }
}